import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { AbstractComponent } from '@sol/components/components/abstract.component';
import { DialogService, DialogServiceState } from '@sol/components/services/dialog.service';
import { TimerTools } from '@sol/components/tools/timer-tools';
import {
  DialogContainerVisibility,
  SolDialogsState,
} from '@sol/components/components/dialog/sol-dialogs/sol-dialogs.state';
import { LabDialogContainerComponent } from '../lab-dialog-container/lab-dialog-container.component';

@Component({
  selector: 'lab-dialogs',
  standalone: true,
  imports: [CdkTrapFocus, LabDialogContainerComponent],
  templateUrl: './lab-dialogs.component.html',
  styleUrl: './lab-dialogs.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LabDialogsComponent extends AbstractComponent<SolDialogsState> {
  private readonly dialogService = inject(DialogService);

  protected entries$ = this.compute(state => state.entries);
  protected visibility$ = this.compute(state => state.visibility);
  protected visible$ = this.compute(state => state.visible);

  private opacityTimer?: Subscription;

  constructor() {
    super(SolDialogsState.of());

    this.dialogService.watch(dss => this.onServiceStateUpdate(dss));
    this.watchComputed(
      state => SolDialogsState.shouldFade(state),
      shouldFade => this.handleFade(shouldFade),
    );
  }

  private onServiceStateUpdate(dss: DialogServiceState): void {
    this.update(state => state.withEntries(dss.entries));
  }

  private handleFade(shouldFade: boolean): void {
    if (!shouldFade) {
      return;
    }
    this.updateVisibility();
    this.opacityTimer?.unsubscribe();
    this.opacityTimer = TimerTools.timer$(150, this.destroyRef).subscribe(() => this.updateVisibility());
  }

  private updateVisibility(): void {
    const visibility: DialogContainerVisibility = SolDialogsState.calculateVisibility(this.state);
    this.update(state => state.withVisibility(visibility));
  }
}
